module.exports = {
  colors: {
    textPrimary: "#1B1B4B",
    textSecondary: "#4D5360",
    textSuccess: "#0F4D31",

    primary: "red",
    primary__hover: "#3B3BA0",
    primary__active: "#292970",

    secondary: "#E8E9EC",
    secondary__hover: "#D8DADF",
    secondary__active: "#ABAEBA",

    bg: "#F2F2F4",
    bg__light: "#FAF9F9",
    bg__hover: "#E8E9EC",
    bg__selected: "#192642",

    success: "#248458",
    success__light: "#E7F9ED",
    info: "#3C5C9D",
    info__light: "#E6EFFF",
    info__background: "#F4F8FF",
    error: "#D40715",
    error__light: "#FED8D9",
    warning: "#9E6C00",
    warning__light: "#FFF4D6",

    placeholder: "#676F7E",

    dataViz: {
      primaryBlue100: "#dce0fc",
      primaryMetricValueColor: "#252528",
      primaryMetricEmptyValueColor: "#ABB4F4",
      primaryMetricTitleColor: "#7A89F4",
      selectedMetricTitleColor: "#1E1F43",
      primaryMetricUnitColor: "#4056F4",
      primaryPieChartColor: "#1E22FF",
      primaryPercentageColor: "#1E1F43",
      lightPercentageColor: "#95959D",
      secondaryBoxIconBackground: "#CFCFD3",
      leftSidebarBgColor: "white",
      headerBgColor: "#232459",
      headerBorderColor: "#4A4CA8",
      headerSectionTitle: "#7A89F4",
      progressBarBgColor: "#3d3f90",
      progressBarColor: "#ffffff",
      boostButtonBgColor: "#ffc82c",
      boostButtonTextColor: "#121214",
      printMetricsValueColor: "#1E1F43",
      printMetricsPercentageColor: "#7A89F4",
      chartMetricBorder: "#DCE0FC",
      targetAchievedTextColor: "#1DBB74",
      targetMissedTextColor: "#7A89F4",
      targetAchievedBoxBgColor: "#EBFEF5",
      targetMissedBoxBgColor: "#EFF1FC",
      attentionBoxBgColor: "#EFF1FC80",
      attentionBoxTextColor: "#7A89F4",
      channelOptionBackgroundColor: "#EFF1FC",
      channelOptionBorderColor: "#ABB4F4",
      attentionBoxTitleColor: "black",
      attentionBoxSectionTitleColor: "#7A89F4",
      attentionBoxDividerColor: "#ABB4F4",
      printMessageColor: "#7A89F4",
      printMessageTitleColor: "#1E1F43",
      winnerDotColor: "#36F99F",
      winnerTextColor: "#7A89F4"
    },
    campaignCreationNavigation: {
      backButtonBorderColor: "#7A89F4",
      backButtonBgColor: "transparent",
      backButtonTextColor: "black",
      backButtonHoverBgColor: "#DCE0FC",
      backButtonHoverTextColor: "black",
      backButtonHoverBorderColor: "#DCE0FC",
      backButtonDisabledBorderColor: "#DCE0FC",
      backButtonDisabledBgColor: "#DCE0FC",
      backButtonDisabledTextColor: "#ABB4F4",
      saveDraftButtonBorderColor: "#7A89F4",
      saveDraftButtonBgColor: "transparent",
      saveDraftButtonTextColor: "black",
      saveDraftButtonHoverBgColor: "#DCE0FC",
      saveDraftButtonHoverTextColor: "black",
      saveDraftButtonHoverBorderColor: "#DCE0FC",
      saveDraftButtonDisabledBorderColor: "#DCE0FC",
      saveDraftButtonDisabledBgColor: "#DCE0FC",
      saveDraftButtonDisabledTextColor: "#ABB4F4",
      continueButtonBgColor: "#36F99F",
      continueButtonTextColor: "#000",
      continueButtonHoverBgColor: "#27DD8B",
      continueButtonDisabledBorderColor: "#DCE0FC",
      continueButtonDisabledBgColor: "#DCE0FC",
      continueButtonDisabledTextColor: "#ABB4F4"
    },
    campaignCreationRightSideBar: {
      containerBackgroundColor: "#EFF1FC",
      containerBorderColor: "#DCE0FC",
      containerErrorBackgroundColor: "#ffd3d3",
      containerErrorBorderColor: "#ff0000"
    },
    campaignMediaAssets: {
      containerBorderColor: "#DCE0FC",
      mediaWidgetBorderColor: "#DCE0FC",
      mediaWidgetBgColor: "#e7ebfc",
      mediaWidgetHeaderBorderColor: "#ABB4F4",
      mediaAssetBgColor: "#DCE0FC",
      attentionBoxLogoBgColor: "#FFF1CA",
      attentionBoxLogoTextColor: "#644A00",
      attentionBoxLogoToggleColor: "#FFDD7B"
    },
    bookingOverview: {
      topUpCreditsContainerBgColor: "#dce0fc",
      topUpCreditsTextColor: "#4056f4",
      topUpCreditsButtonHoveredBgColor: "#1E22FF",
      topUpCreditsButtonHoveredTextColor: "#ffffff"
    },
    adAssistant: {
      previewBoxShadow: "rgba(30, 34, 255, 0.2)",
      previewBgColor: "rgba(220, 224, 252, 0.6)",
      previewBorderColor: "#abb4f4",
      dismissButtonBgColor: "#ff7a61",
      useItButtonBgColor: "#36f99f",
      jobSearcherBgColor: "#eff1fc",
      layoutBgColor: "#00000036",
      titleColor: "#1e1f43",
      primaryColor: "#1e22ff",
      chatMessage: "#dce0fc"
    }
  },
  sizes: {
    campaignCreation: {
      navigationHeight: "80px"
    }
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    xxl: "32px"
  },
  fontSizes: {
    xs: "8px",
    sm: "12px",
    md: "14px",
    lg: "16px",
    xl: "24px"
  },
  borderRadius: {
    xs: "2px",
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "16px"
  },
  breakpoints: {
    mobile: "@media (max-width: 767px)",
    tablet: "@media (min-width: 768px) and (max-width: 1023px)",
    tabletAndUp: "@media (min-width: 768px)",
    desktop: "@media (min-width: 1024px) and (max-width: 1279px)",
    desktopAndUp: "@media (min-width: 1024px)",
    largeDesktop: "@media (min-width: 1280px)",
    largeDesktopAndUp: "@media (min-width: 1280px)",
    extraLargeDesktop: "@media (min-width: 1440px) and (max-width: 1919px)",
    extraLargeDesktopAndUp: "@media (min-width: 1440px)",
    ultraWideDesktop: "@media (min-width: 1920px)"
  }
};
